module.exports = __webpack_public_path__ + "static/media/traemandLogo.309ca33e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/traemandLogo.png
// module id = 1423
// module chunks = 0